module.exports = __webpack_public_path__ + "img/weixin.4413707c.png";